/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SystemSettingHistoryItemResponseDto } from './SystemSettingHistoryItemResponseDto';
import {
    SystemSettingHistoryItemResponseDtoFromJSON,
    SystemSettingHistoryItemResponseDtoFromJSONTyped,
    SystemSettingHistoryItemResponseDtoToJSON,
    SystemSettingHistoryItemResponseDtoToJSONTyped,
} from './SystemSettingHistoryItemResponseDto';

/**
 * 
 * @export
 * @interface SystemSettingHistoryResponseDto
 */
export interface SystemSettingHistoryResponseDto {
    /**
     * 
     * @type {Array<SystemSettingHistoryItemResponseDto>}
     * @memberof SystemSettingHistoryResponseDto
     */
    data: Array<SystemSettingHistoryItemResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof SystemSettingHistoryResponseDto
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof SystemSettingHistoryResponseDto
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof SystemSettingHistoryResponseDto
     */
    limit: number;
}

/**
 * Check if a given object implements the SystemSettingHistoryResponseDto interface.
 */
export function instanceOfSystemSettingHistoryResponseDto(value: object): value is SystemSettingHistoryResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    return true;
}

export function SystemSettingHistoryResponseDtoFromJSON(json: any): SystemSettingHistoryResponseDto {
    return SystemSettingHistoryResponseDtoFromJSONTyped(json, false);
}

export function SystemSettingHistoryResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SystemSettingHistoryResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(SystemSettingHistoryItemResponseDtoFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
    };
}

export function SystemSettingHistoryResponseDtoToJSON(json: any): SystemSettingHistoryResponseDto {
    return SystemSettingHistoryResponseDtoToJSONTyped(json, false);
}

export function SystemSettingHistoryResponseDtoToJSONTyped(value?: SystemSettingHistoryResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(SystemSettingHistoryItemResponseDtoToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
    };
}

